import { type SVGProps } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import type ZepIcon from '@/icons/ZepIcon';
import { type IconSize } from '@/icons/ZepIcon';
import { cn } from '@/utils';
import { Button, type ButtonProps } from '../button';
import { TopLabelSlotIcon } from '../label';
const TextFieldSlotButton = (props?: ButtonProps) => {
  return <Button className="shrink-0" size={'xs'} variant={'transparent'} intent={'alternative'} {...props} data-sentry-element="Button" data-sentry-component="TextFieldSlotButton" data-sentry-source-file="slot.tsx">
      {props?.children}
    </Button>;
};
type TextFieldSlotIconProps = {
  icon: ReturnType<typeof ZepIcon>;
  disabled?: boolean;
} & SVGProps<SVGSVGElement> & {
  size?: IconSize;
};
const TextFieldSlotIcon = ({
  icon,
  disabled = false,
  className,
  ...props
}: TextFieldSlotIconProps) => {
  return icon({
    size: 'md',
    className: cn('shrink-0', className),
    fill: disabled ? ICON_COLOR.disabled : ICON_COLOR.neutral,
    ...props
  });
};
const TextFieldSlotText = ({
  text,
  disabled = false
}: {
  text: string;
  disabled?: boolean;
}) => {
  return <span className={cn('pl-[9px] text-body-lg-medium text-default shrink-0', disabled && 'text-disabled')} data-sentry-component="TextFieldSlotText" data-sentry-source-file="slot.tsx">
      {text}
    </span>;
};
const TextFieldTitleSlotIcon = TopLabelSlotIcon;
const TextFieldSlot = {
  Button: TextFieldSlotButton,
  Icon: TextFieldSlotIcon,
  Text: TextFieldSlotText,
  TitleIcon: TextFieldTitleSlotIcon
};
export { TextFieldSlot };